function normalizeNode(item, nodeType) {
  if (!item || typeof item !== 'object') return null
  const type = String(item.nodeType || nodeType || (item.vehicleNo ? 'VEHICLE' : 'GROUP')).toUpperCase()
  const isVehicle = type === 'VEHICLE'
  const isUngrouped = type === 'UNGROUPED'
  const id = item.nodeId || (isVehicle ? `vehicle:${item.vehicleId || item.id}` : isUngrouped ? 'ungrouped' : `group:${item.groupId || item.id}`)
  const parentId = item.parentNodeId || (isVehicle
    ? (item.groupId ? `group:${item.groupId}` : 'ungrouped')
    : (item.parentId ? `group:${item.parentId}` : null))
  const label = item.label || item.groupName || item.vehicleNo || '未命名'
  return {
    ...item,
    id: String(id),
    parentId: parentId == null ? null : String(parentId),
    nodeType: type,
    label,
    children: []
  }
}

/** 将后端扁平车辆树转换为 Element Tree 所需的层级结构。 */
export function buildVehicleTree(groups = [], vehicles = []) {
  const nodes = [
    ...(groups || []).map(item => normalizeNode(item)),
    ...(vehicles || []).map(item => normalizeNode(item, 'VEHICLE'))
  ].filter(Boolean)
  const nodeMap = {}
  nodes.forEach(node => { nodeMap[node.id] = node })
  const roots = []
  nodes.forEach(node => {
    const parent = node.parentId && nodeMap[node.parentId]
    if (parent) parent.children.push(node)
    else roots.push(node)
  })
  return roots
}

/** 模糊匹配车牌、别名和分组名称，并保留命中节点的祖先。 */
export function filterVehicleTree(nodes, keyword) {
  const query = String(keyword || '').trim().toLowerCase()
  if (!query) return nodes || []
  return (nodes || []).reduce((result, node) => {
    const children = filterVehicleTree(node.children || [], query)
    const text = [node.label, node.vehicleNo, node.aliasName, node.groupName]
      .filter(Boolean)
      .join(' ')
      .toLowerCase()
    if (text.includes(query) || children.length) result.push({ ...node, children })
    return result
  }, [])
}

export function findVehicleNode(nodes, vehicleId) {
  for (const node of nodes || []) {
    if (node.nodeType === 'VEHICLE' && String(node.vehicleId) === String(vehicleId)) return node
    const found = findVehicleNode(node.children || [], vehicleId)
    if (found) return found
  }
  return null
}

export function findTreeNode(nodes, nodeId) {
  for (const node of nodes || []) {
    if (String(node.id) === String(nodeId)) return node
    const found = findTreeNode(node.children || [], nodeId)
    if (found) return found
  }
  return null
}
